import  * as React from "react";
import { observer } from "mobx-react";
import { ICloseButtonParams } from "./ICloseButtonParams";

@observer
export class CloseButton extends React.Component<ICloseButtonParams>{
    constructor(props: ICloseButtonParams) {
        super(props, undefined);
        this.closeSelectedRow = this.closeSelectedRow.bind(this);
    }
    
    closeSelectedRow() {
        this.props.cleanSelectedShot();
    }
    render() {
        let closeCircleStyle = {
            background: this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.color
        }
        return <div className="CloseButton">
                   <div className="close-circle" style={closeCircleStyle} onClick={this.closeSelectedRow}>
                       <img className="x-text" src="Images/MultiShotControl/close-icon.svg" alt="Close button" />
                   </div>
        </div >;
    }
}
